import React from "react";
import "./SeniorInfantPreCreateModal.css";

function SeniorInfantPreCreateModal({
  show,
  onClose,
  onProceed,
  availableClasses,
  fromGradeName,
  toGradeName,
}) {
  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <h2 className="modal-title">{toGradeName} Class Creation</h2>
        </div>
        
        <div className="modal-body">
          {/* Important Notice */}
          <div className="warning-notice">
            <p>
              <strong>Important:</strong> Before creating a new class for {toGradeName}, please make sure it is brand new and not a class coming through from {fromGradeName}.
            </p>
          </div>

          {/* Classes List */}
          <div className="classes-container">
            <div className="classes-header">
              <span>2024 {fromGradeName} Classroom Names</span>
              <span>2025 {toGradeName} Converted Status</span>
            </div>

            <div className="classes-list">
              {availableClasses && availableClasses.length > 0 ? (
                availableClasses.map((classItem, index) => (
                  <div key={index} className="class-item">
                    <span className="class-name">
                      {classItem.name}
                    </span>
                    <span className={`status-badge ${classItem.hasOwner ? 'has-owner' : 'needs-owner'}`}>
                      {classItem.hasOwner ? 'Has Class Owner' : 'Needs Class Owner'}
                    </span>
                  </div>
                ))
              ) : (
                <div className="no-classes-message">
                  No {fromGradeName} classes available for conversion.
                </div>
              )}
            </div>
          </div>
        </div>
        
        <div className="modal-footer">
          <button className="cancel-button" onClick={onClose}>
            Cancel
          </button>
          <button className="proceed-button" onClick={onProceed}>
            Proceed with class creation for {toGradeName}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SeniorInfantPreCreateModal;
